import axios from 'axios'
import userController from '../front/user/controllers/user.controller'
import spinController from './spin/spin.controller'
import { config } from '../config/app'
import layoutController from '../layouts/controllers/layout.controller'
import { storeLocal } from './stores'
import { notification } from 'antd'
import dayjs from 'dayjs'

interface HeaderInterface {
    key?: string,
    value?: string
}

// silent — без глобального спиннера: для фоновых запросов, которые не должны
// мигать им и сбивать его переключение у запросов, запущенных пользователем
export const openApi = async (method: string, path: string, data: any = {}, header: HeaderInterface = { key: '', value: '' }, silent: boolean = false) => {
    const toggleSpin = () => {
        if (!silent) spinController.onChange()
    }

    toggleSpin()

    let access_token = ''
    let refresh_token = ''

    let tokens = await userController.decrypt()

    if(tokens.expires <= dayjs().unix())
        layoutController.logout()

    if(tokens) {
        if(tokens.access_token) access_token = tokens.access_token
        if(tokens.refresh_token) refresh_token = tokens.refresh_token
    }

    let headers = {
        'Authorization': `Bearer ${access_token}`,
        'Refresh-Token': refresh_token,
        'Language': storeLocal.get('lang') ? storeLocal.get('lang') : config.defaultLanguage,
        'Client-Domain': window && window.location && window.location.host && window.location.host !== '' ? window.location.host : '',
        'Cloud-System': 'cloud'
    }

    if(header.key && header.key !== '' && header.value && header.value !== '') { // @ts-ignore
        headers[header.key] = header.value
    }

    const req = axios.create({
        baseURL: `${config.open_api_uri}`,
        headers: headers
    })

    if(method === 'get') {
        return req.get(path)
            .then(result => {
                toggleSpin()
                return result.data
            })
            .catch(error => {
                toggleSpin()
                console.log(error)

                throw error
            })
    } else if(method === 'post') {
        return req.post(path, data)
            .then(result => {
                console.log(result)
                toggleSpin()
                return result.data
            })
            .catch(error => {
                toggleSpin()
                console.log(error)

                throw error
            })
    } else if(method === 'put') {
        return req.put(path, data)
          .then(result => {
              console.log(result)
              toggleSpin()
              return result.data
          })
          .catch(error => {
              toggleSpin()
              console.log(error)

              throw error
          })
    } else if(method === 'delete') {
        return req.delete(path, data)
            .then(result => {
                toggleSpin()
                return result.data
            })
            .catch(error => {
                toggleSpin()
                console.log(error)

                throw error
            })
    }

}
